import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";
import type { QueryType } from "@/common/types/common";

import type { PlanPayloadType } from "@/common/types/plan";

export async function planList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `common/plan/list${queryString}`
    );
}

export async function planGet(
    plan_id: string
) {
    return await clientAxios.get(
        `common/plan/${plan_id}`
    );
}

export async function planAdd(
    payload: PlanPayloadType
) {
    return await clientAxios.post(
        `common/plan/add`,
        payload
    );
}

export async function planEdit(
    plan_id: string,
    payload: PlanPayloadType
) {
    return await clientAxios.put(
        `common/plan/${plan_id}/edit`,
        payload
    );
}

export async function planDel(
    plan_id: string,
) {
    return await clientAxios.del(
        `common/plan/${plan_id}/delete`,
    );
}

export async function adminPlanList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `admin/plan/list${queryString}`
    );
}

export async function adminPlanAdd(
    payload: PlanPayloadType
) {
    return await clientAxios.post(
        `admin/plan/create`,
        payload
    );
}

export async function adminPlanGet(
    plan_id: string
) {
    return await clientAxios.get(
        `admin/plan/${plan_id}/show`
    );
}

export async function adminPlanPatch(
    plan_id: string,
    payload: Partial<PlanPayloadType>
) {
    return await clientAxios.patch(
        `admin/plan/${plan_id}/patch`,
        { payload }
    );
}

export async function adminPlanDel(
    plan_id: string,
) {
    return await clientAxios.del(
        `admin/plan/${plan_id}/delete`,
    );
}